import { Stack, Typography } from "@mui/material";
import { usePatient } from "src/context/PatientProvider";
import ShipmentTracking from "./components/ShipmentTracking";
import ActionItems from "./components/ActionItems/ActionItems";
import { useMemo } from "react";
import { differenceInDays } from "date-fns";
import FitnessAndNutrition from "./components/FitnessAndNutrition";
import { useTranslation } from "react-i18next";
import { usePatientSubscriptions } from "src/context/PatientSubscriptionsProvider/usePatientSubscriptions";
import MembersFavorites from "./components/MembersFavorites";
import CelebrationMessage from "./components/CelebrationMessage";
import PrescriptionNotice from "./components/PrescriptionNotice";
import TryOnce from "./components/TryOnce";
import RecommendedDose from "src/components/RecommendedDose";
import { useGetVisitsListQuery } from "src/api/services/visitApi";
import ActionTask from "src/components/ActionTask";
import WeightTracker from "src/components/WeightTracker";
import { ProductCategories } from "src/api/types";
import PatientWelcomePackage from "src/components/PatientWelcomePackage";
import MeetingSlot from "src/components/MeetingSlot";

const Home = () => {
  const firstName = usePatient((patient) => patient.profile.first_name);
  const email = usePatient((patient) => patient.profile.email);

  const page = "patient-dashboard";
  const { t } = useTranslation();
  const weightLossSubscription = usePatientSubscriptions((subs) =>
    subs.find((s) => s.product_category.name === ProductCategories.WeightLoss),
  );
  const { data: visits } = useGetVisitsListQuery();

  const within15DaysAndGlp1 = useMemo(() => {
    if (weightLossSubscription == null) return;

    const isGlp1 = weightLossSubscription.product.is_glp1;

    const daysDiff = differenceInDays(
      new Date(),
      new Date(weightLossSubscription.created_at),
    );

    return daysDiff <= 15 && isGlp1;
  }, [weightLossSubscription]);

  const completedWeightLossVisit = useMemo(() => {
    if (visits == null) return [];

    const weightLossVisits = visits.filter(
      (v) => v.product_category.name === ProductCategories.WeightLoss,
    );

    return weightLossVisits.some((v) => v.status === "completed");
  }, [visits]);

  return (
    <Stack gap={2}>
      <Typography variant="h4" fontWeight={600}>
        {`${t(`${page}.welcome`)} ${firstName}`}
      </Typography>
      <CelebrationMessage />
      {within15DaysAndGlp1 ? <PatientWelcomePackage /> : null}
      <PrescriptionNotice />
      {email.includes("@holavida") ? <MeetingSlot /> : null}
      <ActionItems />
      <RecommendedDose />
      <ShipmentTracking page={page} />
      <ActionTask type="DISCOUNT_OFFER" />
      <ActionTask type="WL_OPTIONS" />
      <WeightTracker />
      {completedWeightLossVisit ? <FitnessAndNutrition page={page} /> : null}
      <TryOnce />
      <MembersFavorites />
    </Stack>
  );
};

export default Home;
